import { isMobile, isTablet } from './device';

export const iOS = () => {
    const safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return (
        (['iPhone Simulator', 'iPhone'].includes(navigator.platform) && safari) ||
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document && safari)
    );
};

export const isValidBrowser = () => {
    const nav = navigator.userAgent;
    if (nav.toLowerCase().indexOf('android') === -1) return false;
    const isChrome = /Chrome/.test(nav) && /Google Inc/.test(navigator.vendor);
    const isOpera = nav.indexOf('Opera') > -1;
    if (isChrome || isOpera) return true;
    return false;
};

export const fullScreenMode = () => {
    if (isMobile() || isTablet()) {
        const doc = window.document as any;
        const docEl = doc.documentElement;
        const requestFullScreen =
            docEl.requestFullscreen ||
            docEl.mozRequestFullScreen ||
            docEl.webkitRequestFullScreen ||
            docEl.msRequestFullscreen;

        if (
            !doc.fullscreenElement &&
            !doc.mozFullScreenElement &&
            !doc.webkitFullscreenElement &&
            !doc.msFullscreenElement
        ) {
            requestFullScreen.call(docEl).then(() => {
                if (isValidBrowser()) {
                    setTimeout(() => {
                        const scr: any = window.screen;
                        scr.orientation.lock('landscape');
                    }, 200);
                }
            });
        }
    }
};
